<template>
  <div>
    <figure class="figure">
      <img :src="block.value.src" class="figure-img img-fluid rounded" :alt="block.value.alt" />
      <figcaption v-if="block.value.caption" class="figure-caption text-end">
        {{ block.value.caption }}
      </figcaption>
    </figure>
  </div>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
const {block} = defineProps<{block: SphereBlock<'image_block'>}>();
</script>
